export const adaptInsumo = (insumo) => {
    return {
        id: insumo?.idInsumoN,
        label: insumo?.descripcion,
        unidad: insumo?.idUnidadNavigation?.alias,
        idUnidad: insumo?.idUnidad
    }
}

export const adaptInsumosArray = (
    insumos
) => {
    return structuredClone(insumos?.allInsumosRI)
        ?.map(insumo => adaptInsumo(insumo));
}